function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 9,
  width: 26,
  height: 16,
  rx: 1,
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.247 16.627a1 1 0 001.506 1.317L8 17.661v4.34a1 1 0 001 1h3a1 1 0 100-2h-2v-3.34l.248.283a1 1 0 101.505-1.317l-2-2.285a.995.995 0 00-1.094-.282.995.995 0 00-.412.281l-2 2.286zM27.753 17.373a1 1 0 00-1.506-1.317l-.247.283v-4.34a1 1 0 00-1-1h-3a1 1 0 100 2h2v3.34l-.247-.283a1 1 0 10-1.506 1.317l2 2.285a.995.995 0 001.094.282.995.995 0 00.412-.282l2-2.285z",
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.205 20.705h0a6.516 6.516 0 01-.849-.333m.85.333l-1.15-1.391a.664.664 0 01.354-.357m.795 1.748l.004.001c.308.091.652.152 1.033.184v.48c0 .215.078.401.233.549a.794.794 0 00.58.231.78.78 0 00.57-.231.733.733 0 00.234-.549v-.535c.645-.125 1.18-.376 1.6-.76.46-.414.691-.944.691-1.58 0-.553-.183-1.016-.554-1.376-.36-.364-.909-.614-1.624-.764h0l-1.228-.252s0 0 0 0c-.354-.075-.578-.167-.698-.261a.458.458 0 01-.157-.358c0-.21.092-.384.3-.527.21-.145.512-.226.922-.226.339 0 .616.031.836.09.228.06.438.135.628.222.253.12.496.163.71.09h0l.003-.002a.787.787 0 00.503-.953c-.048-.213-.184-.38-.386-.5a3.128 3.128 0 00-.81-.373 5.074 5.074 0 00-.736-.176v-.5c0-.214-.079-.4-.234-.547a.78.78 0 00-.57-.232.794.794 0 00-.58.232.733.733 0 00-.233.548v.533c-.674.12-1.227.38-1.648.786a2.14 2.14 0 00-.677 1.598c0 .572.18 1.051.547 1.422.364.368.899.617 1.587.76h0l1.218.252h0c.38.076.613.172.73.272a.446.446 0 01.169.358c0 .175-.078.325-.259.455-.174.125-.495.203-.997.203-.448 0-.82-.045-1.12-.13m-.587 1.566l.587-1.566m-1.436 1.233s0 0 0 0l.065-.135-.064.136s0 0 0 0zm0 0c-.234-.11-.4-.276-.466-.502v-.001h0a.915.915 0 01.027-.613l.002-.003h0a.813.813 0 01.43-.433m0 0s0 0 0 0l.061.137m-.06-.137c.221-.1.467-.073.72.043l.006.002h0c.166.086.403.177.716.274m-1.442-.32s0 0 0 0l.06.138m0 0l1.382.181",
  fill: "#A0AFBE",
  stroke: "#A0AFBE",
  strokeWidth: 0.3
}));
function SvgSyncSalesButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none"
  }, props), _ref);
}
export default SvgSyncSalesButton;